import {
  BookingsApi,
  Configuration,
  CourseModulesApi,
  LearnerProgressApi,
  ModulesApi,
  MediaApi,
  MediaTrainingCourseApi,
  NotificationsApi,
  OrganisationGroupApi,
  OrganisationApi,
  StandUpTasksApi,
  TrainingApi,
  TrainingOptixApi,
  TrainingCourseAssignmentsApi,
  TrainingDeliveryModesApi,
  TrainingLocationsApi,
  TrainingValidityPeriodsApi,
  SCORMApi,
  SCORMRuntimeApi,
  SCORMSearchApi,
  SCORMTemplatesApi,
  TrainingAssessmentsApi,
  TrainingAssessmentAnswersApi,
  TrainingAssessmentAttemptsApi,
  TrainingAssessmentQuestionsApi,
  TrainingAssessmentEnrollmentsApi,
  TrainingCohortsApi,
  TrainingAssessorsApi,
  TrainingCertificatesApi,
  TrainingOptixEnrollmentsApi,
  TrainingFacilitatorsApi,
  TrainingLearnerOverviewApi,
  TrainingManagerPortalOverviewApi,
  TrainingSkillsProgramEnrollmentsApi,
  TrainingQualificationEnrollmentsApi,
  TrainingLearnersApi,
  TrainingModeratorsApi,
  TrainingOptixQualificationsApi,
  TrainingOptixSkillsProgramsApi,
  TrainingOptixTrainingCourseTypesApi,
  TrainingTemplatesAssessmentAnswersApi,
  TrainingTemplatesAssessmentQuestionsApi,
  TrainingTemplatesAssessmentsApi,
  TrainingTemplatesAssignmentsApi,
  TrainingTemplatesQualificationsApi,
  TrainingTemplatesSkillsProgramsApi,
  UserApi,
  UserProfileSummaryApi,
  UserUploadApi,
} from '@onroadvantage/optix-safeandsound-openapi';

import {config} from './modules/common/services/configService';
import {useAuthStore} from './modules/common/stores/authStore';

const getToken = async (): Promise<string> => {
  try {
    let token = '-';
    const authToken = useAuthStore.getState().token;
    if (authToken != null) {
      token = authToken;
    }
    return `Bearer ${token}`;
  } catch (e) {
    return '-';
  }
};

const configuration = new Configuration({
  basePath: config.serverUri,
  accessToken: getToken,
  headers: {Origin: window.origin},
});

const proxyConfiguration = new Configuration({
  basePath: '',
  accessToken: getToken,
  headers: {Origin: window.origin},
});

export const organisationApi = new OrganisationApi(configuration);
export const organisationGroupApi = new OrganisationGroupApi(configuration);
export const courseModulesApi = new CourseModulesApi(configuration);
export const learnerProgressApi = new LearnerProgressApi(configuration);
export const modulesApi = new ModulesApi(configuration);
export const trainingApi = new TrainingApi(configuration);
export const trainingOptixApi = new TrainingOptixApi(configuration);
export const trainingCourseAssignmentsApi = new TrainingCourseAssignmentsApi(
  configuration,
);
export const scormApi = new SCORMApi(configuration);
export const proxyScormApi = new SCORMApi(proxyConfiguration);
export const scormRuntimeApi = new SCORMRuntimeApi(configuration);
export const scormSearchApi = new SCORMSearchApi(configuration);
export const scormTemplatesApi = new SCORMTemplatesApi(configuration);
export const trainingAssessmentAnswersApi = new TrainingAssessmentAnswersApi(
  configuration,
);
export const trainingAssessmentAttemptsApi = new TrainingAssessmentAttemptsApi(
  configuration,
);
export const trainingAssessmentQuestionsApi =
  new TrainingAssessmentQuestionsApi(configuration);
export const trainingAssessmentsApi = new TrainingAssessmentsApi(configuration);
export const trainingAssessmentEnrollmentsApi =
  new TrainingAssessmentEnrollmentsApi(configuration);
export const trainingAssessorsApi = new TrainingAssessorsApi(configuration);
export const trainingCertificatesApi = new TrainingCertificatesApi(
  configuration,
);
export const trainingCohortsApi = new TrainingCohortsApi(configuration);
export const trainingOptixEnrollmentsApi = new TrainingOptixEnrollmentsApi(
  configuration,
);
export const trainingSkillsProgramEnrollmentsApi =
  new TrainingSkillsProgramEnrollmentsApi(configuration);
export const trainingQualificationEnrollmentsApi =
  new TrainingQualificationEnrollmentsApi(configuration);
export const trainingFacilitatorsApi = new TrainingFacilitatorsApi(
  configuration,
);
export const trainingLearnerOverviewApi = new TrainingLearnerOverviewApi(
  configuration,
);
export const trainingManagerPortalOverviewApi =
  new TrainingManagerPortalOverviewApi(configuration);
export const trainingLearnersApi = new TrainingLearnersApi(configuration);
export const trainingModeratorsApi = new TrainingModeratorsApi(configuration);
export const trainingCourseTypesApi = new TrainingOptixTrainingCourseTypesApi(
  configuration,
);
export const trainingOptixQualificationsApi =
  new TrainingOptixQualificationsApi(configuration);
export const trainingOptixSkillsProgramsApi =
  new TrainingOptixSkillsProgramsApi(configuration);
export const trainingTemplatesSkillsProgramsApi =
  new TrainingTemplatesSkillsProgramsApi(configuration);
export const trainingTemplatesQualificationsApi =
  new TrainingTemplatesQualificationsApi(configuration);
export const trainingTemplatesAssignmentsApi =
  new TrainingTemplatesAssignmentsApi(configuration);
export const trainingTemplatesAssessmentsApi =
  new TrainingTemplatesAssessmentsApi(configuration);
export const trainingTemplatesAssessmentQuestionsApi =
  new TrainingTemplatesAssessmentQuestionsApi(configuration);
export const trainingTemplatesAssessmentAnswersApi =
  new TrainingTemplatesAssessmentAnswersApi(configuration);
export const bookingsApi = new BookingsApi(configuration);
export const trainingDeliveryModesApi = new TrainingDeliveryModesApi(
  configuration,
);
export const trainingLocationsApi = new TrainingLocationsApi(configuration);
export const trainingValidityPeriodsApi = new TrainingValidityPeriodsApi(
  configuration,
);
export const mediaApi = new MediaApi(configuration);
export const mediaTrainingCourseApi = new MediaTrainingCourseApi(configuration);
export const notificationsApi = new NotificationsApi(configuration);
export const userApi = new UserApi(configuration);
export const userProfileSummaryApi = new UserProfileSummaryApi(configuration);
export const userUploadApi = new UserUploadApi(configuration);
export const standUpTasksApi = new StandUpTasksApi(configuration);
